import React from 'react';
import './CardLandingPage.css';

function CardLandingPage({ id, title, content }) {
  return (
    <div className="mycard-container">
      <div className="mycard-circle">{id}</div>
      <div className='p-3'>
        <h3 className="mycard-title">{title}</h3>
        <p className="mycard-content">{content}</p>
      </div>
    </div>
  );
}

export default CardLandingPage;
